import { Box, IconButton, Menu, MenuItem, Button, Switch } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import SearchBar from "../../components/SearchBar";
import TableComponent from "../../components/TableComponent";
import MainContainer from "../../layout/MainContainer";
import { VEHICLE_TYPE } from "../../utils/enums";
const MyListings = () => {
  const navigate = useNavigate();
  const [hidden, setHidden] = useState<string[]>([]);

  const [searchTerm, setSearchTerm] = useState("");

  const rows = [
    {
      id: 1,
      vehicleType: 1,
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
    },
    {
      id: 2,
      vehicleType: 2,
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
    },
    {
      id: 3,
      vehicleType: 3,
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
    },
    {
      id: 4,
      vehicleType: 4,
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
    },
    {
      id: 5,
      vehicleType: 1,
      address: "1425 10th Avenue, PO Box 4001, Victoria BC V8X 3X4, Canada ",
    },
  ];

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 0.6,
      minWidth: 100,
      field: "vehicle",
      headerName: "Vehicle Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: "16px" }}>
            <figure
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/listing-detail/${row?.vehicleType}`)}
            >
              <img src="/static/images/vehicle_side.jpg" alt="" />
            </figure>
            <p>
              #CR00001<b>Baleno</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "vehicleType",
      headerName: "Vehicle Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              <b>car</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.8,
      minWidth: 200,
      field: "name",
      headerName: "Listing Assigned to",
      editable: false,
      sortable: false,

      renderCell: () => {
        return (
          <div className="user_block">
            <figure>
              <img src="/static/images/user_attachment.jpg" alt="" />
            </figure>
            <p>
              <b>Emma Smith</b> +9203024595467 <br />
              emma@gmail.com
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Block/Unblock",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            defaultChecked
            // onChange={() => updateStatus(row?._id)}
          />
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 150,
      field: "premimStatus",
      filterable: false,
      sortable: false,
      headerName: "Premium Listing",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            defaultChecked
            // onChange={() => updateStatus(row?._id)}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={handleClick1}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleClose1}>View</MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate(`/listings/edit/${1}`);
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>
                <MenuItem onClick={handleClose1}>Delete</MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  return (
    <MainContainer>
      <div className="main_title">
        <h1>My Listings </h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Listings - My Listings
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setSearchTerm}
                  placeholder="Search"
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button
                  className="btn btn_orange"
                  onClick={() => {
                    navigate("/listings/add");
                  }}
                >
                  Add Vehicle
                </Button>
              </Box>
            </div>
          </div>
          <div className="sorting_table">
            <TableComponent
              columns={columns?.filter(
                (item: any) => !hidden.includes(item.field)
              )}
              rows={rows}
            />
          </div>
        </Box>
      </div>
    </MainContainer>
  );
};

export default MyListings;
